import styles from "./index.module.scss"

export const ComingSoon = () => {
  return (
    <div className={styles.messageWrapper}>
      <div className={styles.message}>Coming soon</div>
    </div>
  )
}
